import type { CreateClientFormData, EditClientData } from '@/types/clientsApiTypes';

type BasicInfoFields = Pick<
  CreateClientFormData['primary_passenger']['client'],
  | 'client_id'
  | 'client_mailing_address'
  | 'client_mailing_address_line_2'
  | 'client_mailing_city'
  | 'client_mailing_state'
  | 'client_mailing_country'
  | 'zip_code'
  | 'client_billing_address'
  | 'client_billing_address_line_2'
  | 'client_billing_city'
  | 'client_billing_state'
  | 'client_billing_country'
  | 'billing_zip_code'
  | 'is_billing_same_as_mailing'
>;

export const getAddressPayload = (values: BasicInfoFields): Partial<EditClientData['client']> => {
  return {
    id: values.client_id,
    client_mailing_address: values.client_mailing_address,
    client_mailing_address_line_2: values.client_mailing_address_line_2,
    client_mailing_city: values.client_mailing_city,
    client_mailing_state: values.client_mailing_state,
    client_mailing_country: values.client_mailing_country,
    zip_code: values.zip_code,
    client_billing_address: values.client_billing_address,
    is_billing_same_as_mailing: values.is_billing_same_as_mailing,
    client_billing_address_line_2: values.client_billing_address_line_2,
    client_billing_city: values.client_billing_city,
    client_billing_state: values.client_billing_state,
    client_billing_country: values.client_billing_country,
    billing_zip_code: values.billing_zip_code,
  };
};

type RelatedAddressFields = Pick<
  CreateClientFormData['primary_passenger']['client'],
  | 'client_id'
  | 'client_mailing_address'
  | 'client_mailing_address_line_2'
  | 'client_mailing_city'
  | 'client_mailing_state'
  | 'client_mailing_country'
  | 'zip_code'
  | 'client_billing_address'
  | 'client_billing_address_line_2'
  | 'client_billing_city'
  | 'client_billing_state'
  | 'client_billing_country'
  | 'billing_zip_code'
  | 'is_billing_same_as_mailing'
>;

export const getRelatedAddressPayload = (values: RelatedAddressFields): Partial<EditClientData['client']> => {
  return {
    id: values.client_id,
    client_mailing_address: values.client_mailing_address,
    client_mailing_address_line_2: values.client_mailing_address_line_2,
    client_mailing_city: values.client_mailing_city,
    client_mailing_state: values.client_mailing_state,
    client_mailing_country: values.client_mailing_country,
    zip_code: values.zip_code,
  };
};
